module.exports = __webpack_public_path__ + "static/img/loading.b0557e8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = JRsF
// module chunks = 15